$(document).ready(function () {
    $(document).on("click", "a[href^='#']", function (e) {
        e.preventDefault();

        const targetHref = $(this).attr('href');
        const targetId = targetHref.substring(targetHref.indexOf('#') + 1);
        const targetElement = $('#' + targetId);

        console.log(targetElement)
        const header_h = $('.header-fixed').innerHeight();

        if (targetElement.length) {
            $('html, body').animate({
                scrollTop: targetElement.offset().top - header_h
            }, 1000);
        }
    });
});

